import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileTerhesseg(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileTerhesseg(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
